export const FormMessages = {
  CreateFormAppNavigation: 'CREATE_FORM_APP_NAVIGATION'
};